import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment-jalaali';

import * as reserveTimeActions from '../../../redux/reserveTimes/actions';

import Spin from '../../../components/loading';
import RseeTimePicker from '../../../components/timePicker';
import DatePicker from '../../../components/FormElements/DatePicker/DatePicker';

import ENUMS from '../../../enums';
import { toStandard } from '../../../utils/formatter';
import { toEnglishDigit } from '../../../utils/toEnglishDigit';
import AlertAndConfirmation from '../../../utils/AlertAndConfirmation';

class CreateReserveDay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      date: ' ',
      loaded: false,
      reserveTypes: !this.props.location.editMode ? ['MORE_THAN_FIVE', 'NORMAL'] : [],
      status: null,
      reservationDayDetails: {},
      meals: []
    };
  }

  formRefrence = React.createRef();

  componentWillUnmount() {
    this.forceUpdate();
  }

  componentDidMount() {
    if (this.props.location.editMode)
      this.props.fetchReservationDayDetails(this.props.location.reservationDayId);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.location.editMode &&
      prevState.loaded == false &&
      Object.entries(this.props.reservationDayDetails).length
    ) {
      let { status, meals = [], date, reserveTypes = [] } = this.props.reservationDayDetails;

      this.setState({ status, meals, date, reserveTypes, loaded: true });
    }
  }

  handleTimeChange = (value, meal, isFromTimeChange) => {
    this.setState(state => {
      let index = state.meals.findIndex(item => item.mealType == meal.value);
      if (index > -1) {
        if (isFromTimeChange) state.meals[index].fromTime = value;
        else state.meals[index].toTime = value;
      }
      return '';
    });
  };

  handleReserveTypesChange = (event, type) => {
    let { checked } = event.target;
    let reserveTypes = [...this.state.reserveTypes];
    if (checked) {
      if (!reserveTypes.some(item => item == type)) {
        let index = reserveTypes.findIndex(item => item == type);
        reserveTypes.push(type);
      }
    } else {
      if (reserveTypes.some(item => item == type)) {
        let index = reserveTypes.findIndex(item => item == type);
        reserveTypes.splice(index, 1);
      }
    }
    this.setState({ reserveTypes });
  };

  handleStatusChange = (event, status) => {
    this.setState({ status });
  };

  onChangeDate = v => {
    this.setState({ date: v });
  };

  submitForm = () => {
    const newStateDate = moment(this.state.date, 'YYYY/M/D').format('jYYYY/jMM/jDD');
    const updatedStateDate = toEnglishDigit(newStateDate);
    let { reserveTypes, status, meals } = this.state;
    let reservationObject = {};
    reservationObject.id = this.props.location.editMode ? this.props.reservationDayDetails.id : undefined;
    reservationObject.date = this.props.location.editMode
      ? updatedStateDate
      : this.formRefrence.current[0].value;
    reservationObject.reserveTypes = reserveTypes;
    reservationObject.status = status;
    reservationObject.meals = meals;
    if (this.props.location.editMode) {
      this.props.updateReservationDay(reservationObject).then(() => {
        let { updateFailed, updateMessage, updateError } = this.props;
        if (updateFailed == false && updateMessage == null && updateError == false) {
          AlertAndConfirmation({
            title: locales('titles.editionsDoneSuccessfully'),
            text: '',
            type: 'success'
          });
          this.props.history.push('/reservation-days-management');
        }
      });
    } else {
      this.props.insertNewReservationDay(reservationObject).then(() => {
        let { failed, message, error } = this.props;
        if (failed == false && message == null && error == false) {
          AlertAndConfirmation({
            title: locales('titles.insertedSuccessully'),
            text: '',
            type: 'success'
          });
          this.props.history.push('/reservation-days-management');
        }
      });
    }
  };

  handlePortionChange = (event, meal) => {
    let { checked } = event.target;
    let meals = [...this.state.meals];
    if (checked) {
      if (!meals.some(item => item.mealType == meal.value)) {
        let index = meals.findIndex(item => item.mealType == meal.value);
        meals.push({
          mealType: meal.value,
          cafeDateId: index > -1 ? meals[index].cafeDateId : undefined,
          id: index > -1 ? id : undefined,
          fromTime: index > -1 ? meals[index].fromTime : '',
          toTime: index > -1 ? meals[index].toTime : ''
        });
      }
    } else {
      if (meals.some(item => item.mealType == meal.value)) {
        let index = meals.findIndex(item => item.mealType == meal.value);
        meals.splice(index, 1);
      }
    }
    this.setState({ meals });
  };

  render() {
    const {
      loading,
      message,
      failed,
      error,
      detailsLoading,
      detailsFailed,
      detailsError,
      detailsMessage,
      updateLoading,
      updateFailed,
      updateError,
      updateMessage
    } = this.props;

    const { status, meals, date, reserveTypes } = this.state;

    return (
      <>
        <div className="col-12 d-flex justify-content-between align-items-center">
          <h3 className="text-right text-muted py-4">
            <div className="text-right">{locales('titles.insertOrEditReservation')}</div>
          </h3>
          <div>
            <button onClick={() => this.submitForm()} className="btn btn-success w-5 mx-1">
              <i className="fa fa-save" />
              {locales('labels.save')}
            </button>
            <button
              onClick={() => this.props.history.push('/reservation-days-management')}
              className="btn btn-default w-5 mx-1"
            >
              <i className="fa fa-reply" />
              {locales('labels.cancel')}
            </button>
          </div>
        </div>
        <section className="p-1 col-12">
          <Spin spinning={loading || detailsLoading || updateLoading}>
            <article>
              <main className="panel panel-default">
                {(error || detailsError || updateError) && (
                  <div className="alert alert-danger">{locales('messages.server.error')}</div>
                )}
                {(failed || detailsFailed || updateFailed) && (
                  <div className="alert alert-danger">{message || detailsMessage || updateMessage}</div>
                )}
                <Spin spinning={loading}>
                  <div className="panel-heading">
                    <i className="fas fa-list-alt px-1" />
                    {locales('titles.insertOrEditReservationFrom')}
                  </div>
                  <div className="panel-body">
                    <div className="col-5 p-0">
                      <form ref={this.formRefrence}>
                        {!this.props.location.editMode && (
                          <DatePicker
                            marge={true}
                            placeholder="تاریخ روز رزرو"
                            name="date"
                            onChange={this.onChangeDate}
                            value={date}
                            className="col p-0 date-picker-input start border rounded py-2"
                          />
                        )}
                        {this.props.location.editMode && (
                          <input
                            name="date"
                            value={date}
                            className="col p-0 date-picker-input start border rounded py-2"
                            disabled={this.props.location.editMode}
                          />
                        )}
                      </form>
                    </div>
                    <div className="col-12 my-4">
                      <label className="col-12 p-0 my-2" htmlFor="mealMeals">
                        {locales('tables.dayMealPortion')} :
                      </label>
                      <div className="col-12 border rounded py-3">
                        <div className="col-12 p-0 d-flex justify-content-center align-items-center">
                          {ENUMS.MEAL_PORTIONS.list.map((meal, index) => (
                            <div key={index} className="col-4 border rounded p-1 mx-1">
                              <div className={`col-12 d-flex px-1 justify-content-start align-items-center`}>
                                <label className="my-2 mx-1" htmlFor={`status-${index}`}>
                                  {meal.title}
                                </label>
                                <input
                                  type="checkbox"
                                  onChange={event => this.handlePortionChange(event, meal)}
                                  checked={meals.some(item => item.mealType == meal.value)}
                                  name={meal.value}
                                  id={meal.value}
                                  className="my-2"
                                />
                              </div>
                              <div className="col-12 d-flex justify-content-between align-items-center p-0">
                                <div className="col-6 p-0">
                                  <label className="col-3 p-1" htmlFor={`fromTime-${meal.value}`}>
                                    {locales('labels.financial.transaction.createdFrom')} :
                                  </label>
                                  <RseeTimePicker
                                    disabled={meals.some(item => item.mealType == meal.value) ? false : true}
                                    onChange={event => this.handleTimeChange(event, meal, true)}
                                    type="time"
                                    value={
                                      meals.some(item => item.mealType == meal.value)
                                        ? toStandard(
                                            meals.filter(item => item.mealType == meal.value)[0].fromTime
                                          )
                                        : ''
                                    }
                                    id={`fromTime-${meal.value}`}
                                    name={`fromTime-${meal.value}`}
                                    className="form-control col-9"
                                  />
                                </div>
                                <div className="col-6 p-0">
                                  <label className="col-3 p-1" htmlFor={`toTime-${meal.value}`}>
                                    {locales('labels.financial.transaction.createdTo')} :
                                  </label>
                                  <RseeTimePicker
                                    type="time"
                                    disabled={meals.some(item => item.mealType == meal.value) ? false : true}
                                    onChange={event => this.handleTimeChange(event, meal, false)}
                                    value={
                                      meals.some(item => item.mealType == meal.value)
                                        ? toStandard(
                                            meals.filter(item => item.mealType == meal.value)[0].toTime
                                          )
                                        : ''
                                    }
                                    id={`toTime-${meal.value}`}
                                    name={`toTime-${meal.value}`}
                                    className="form-control col-9"
                                  />
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                    <div className="col-12 p-0 my-4 d-flex align-items-center justify-content-between">
                      <div className="col-6">
                        <label className="col-12 p-0 my-2" htmlFor="reservationTypes">
                          {locales('tables.reservationType')} :
                        </label>
                        <div className="col-12 border rounded py-3">
                          <div className="col-12 p-0 d-flex justify-content-start align-items-center">
                            {ENUMS.RESERVATION_TYPES.list.map((reservationType, index) => (
                              <div key={index} className="col-4 p-1 mx-1">
                                <div
                                  className={`col-12 d-flex px-1 justify-content-start align-items-center`}
                                >
                                  <label className="my-2 mx-1" htmlFor={reservationType.value}>
                                    {reservationType.title}
                                  </label>
                                  <input
                                    onChange={event =>
                                      this.handleReserveTypesChange(event, reservationType.value)
                                    }
                                    type="checkbox"
                                    checked={reserveTypes.some(item => item === reservationType.value)}
                                    name={reservationType.value}
                                    id={reservationType.value}
                                    className="my-2"
                                  />
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>

                      <div className="col-6">
                        <label className="col-12 p-0 my-2" htmlFor="status">
                          {locales('tables.status')} :
                        </label>
                        <div className="col-12 border rounded py-3">
                          <div className="col-12 p-0 d-flex justify-content-start align-items-center">
                            {ENUMS.RESERVATION_STATUS.list.map((enumstatus, index) => (
                              <div key={index} className="col-4 p-1 mx-1">
                                <div
                                  className={`col-12 d-flex px-1 justify-content-start align-items-center`}
                                >
                                  <label className="my-2 mx-1" htmlFor={enumstatus.value}>
                                    {enumstatus.title}
                                  </label>
                                  <input
                                    onChange={event => this.handleStatusChange(event, enumstatus.value)}
                                    type="radio"
                                    checked={status == enumstatus.value}
                                    name={'status'}
                                    id={enumstatus.value}
                                    className="my-2"
                                  />
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Spin>
              </main>
            </article>
          </Spin>
        </section>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.reserveTimesReducer.insertNewReservationDayLoading,
    message: state.reserveTimesReducer.insertNewReservationDayMessage,
    failed: state.reserveTimesReducer.insertNewReservationDayFailed,
    error: state.reserveTimesReducer.insertNewReservationDayError,

    updateLoading: state.reserveTimesReducer.updateReservationDayLoading,
    updateMessage: state.reserveTimesReducer.updateReservationDayMessage,
    updateFailed: state.reserveTimesReducer.updateReservationDayFailed,
    updateError: state.reserveTimesReducer.updateReservationDayError,

    detailsLoading: state.reserveTimesReducer.reservationDayDetailsLoading,
    detailsMessage: state.reserveTimesReducer.reservationDayDetailsMessage,
    detailsFailed: state.reserveTimesReducer.reservationDayDetailsFailed,
    detailsError: state.reserveTimesReducer.reservationDayDetailsError,
    reservationDayDetails: state.reserveTimesReducer.reservationDayDetails
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchReservationDayDetails: id => dispatch(reserveTimeActions.fetchReservationDayDetails(id)),
    insertNewReservationDay: reservationObject =>
      dispatch(reserveTimeActions.insertNewReservationDay(reservationObject)),
    updateReservationDay: reservationObject =>
      dispatch(reserveTimeActions.updateReservationDay(reservationObject))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateReserveDay);
